import { DisbursementRouting } from './DisbursementRouting';

export const DisbursementModule = () => {
  return <DisbursementRouting />;
};
